import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import { formatNumber } from "../utils/helpers";
import { useState, useEffect } from "react";
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import config from "../config/config";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

export default function ProductPreview({
    form,
    productImagePreview,
    categoryName,
}) 

{
  // Get dữ liệu cho Thẻ Kho
  const { token } = useAuth();
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(false);
  // phan trang cho tag kho
  const [visibleCount, setVisibleCount] = useState(10);
  const fetchOrders = async () => {
    try {
      const res = await axios.get(`${config.backendUrl}/api/orders?page=1&limit=50000`, {
        headers: { "x-auth-token": token },
      });

      // lọc orrders có IP của product
      const filteredOrders = res.data.docs.filter((order) => order.items.some((item) => item?.product?._id === form._id));
      // console.log("lay san pham da loc: ", filteredOrders)
      

      setOrders(filteredOrders || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleToggle = () => {
    if (!open && orders.length === 0) {
      fetchOrders();  // Chỉ fetch lần đầu khi mở
    }
    setOpen(!open);
  };
// Kết Thúc Get dữ liệu cho Thẻ Kho
  return (
    <Box sx={{ p: 1 }}>
      {/* Header */}
      {/* <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography fontWeight="bold" color="text.secondary">
          THÔNG TIN CƠ BẢN
        </Typography>
        <Button size="small" variant="text">Sửa</Button>
      </Box> */}

            {/* Avatar + Tên sản phẩm */}
            <Box display="flex" alignItems="center" mt={2}>
                <Avatar
                    src={productImagePreview}
                    alt={form.name}
                    variant="rounded"
                    sx={{ width: 64, height: 64, mr: 2 }}
                />
                <Box>
                    <Typography fontWeight="bold">{form.name}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Mã hàng: {form.sku}
                    </Typography>
                </Box>
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* Giá vốn + Giá bán */}
            <Grid
                container
                spacing={2}
                sx={{ mb: 1 }}
                justifyContent="space-between"
            >
                <Grid item xs={6} sx={{ pr: 1 }}>
                    <Typography color="text.secondary">Giá vốn</Typography>
                    <Typography fontWeight="bold">
                        {formatNumber(form.costPrice)}
                    </Typography>
                </Grid>
                <Grid item xs={6} sx={{ pl: 1, textAlign: "right" }}>
                    <Typography color="text.secondary">Giá bán</Typography>
                    <Typography fontWeight="bold">
                        {formatNumber(form.price)}
                    </Typography>
                </Grid>
            </Grid>

            <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6} sx={{ pr: 1 }}>
                    <Typography color="text.secondary">Nhóm hàng</Typography>
                    <Typography fontWeight="bold">{categoryName}</Typography>
                </Grid>
                <Grid item xs={6} sx={{ pl: 1, textAlign: "right" }}>
                    <Typography color="text.secondary">Tồn kho</Typography>
                    <Typography fontWeight="bold">{form.quantity}</Typography>
                </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            {/* Mô tả */}
            <Box>
                {form.description ? (
                    <>
                        <Typography color="text.secondary">Mô tả</Typography>
                        <Typography fontWeight="bold">
                            {form?.description}
                        </Typography>
                    </>
                ) : (
                    <Typography color="text.secondary">
                        Chưa có mô tả sản phẩm
                    </Typography>
                )}
            </Box>

            {/* Định mức tồn kho */}
            <Box mt={2}>
                <Typography color="text.secondary">Định mức tồn kho</Typography>
                <Typography fontWeight="bold">0 - 999,999,999</Typography>
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* thẻ tag kho*/}

            <Box mt={2} display="flex" alignItems="center">
                <Typography fontWeight="bold" mr={2}>
                    Thẻ kho
                </Typography>
                <Button size="small" variant="outlined" onClick={handleToggle}>
                    {open ? "Ẩn" : "Xem"}
                </Button>
            </Box>

            {open && (
                <Box mt={2}>
                    <TableContainer
                        component={Paper}
                        sx={{ borderRadius: 2, mb: 2 }}
                    >
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            color: "gray",
                                        }}
                                    >
                                        GIAO DỊCH
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            color: "gray",
                                        }}
                                        align="right"
                                    >
                                        SỐ LƯỢNG
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            color: "gray",
                                        }}
                                        align="right"
                                    >
                                        TỒN CUỐI
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {orders.length > 0 ? (
                                    orders
                                        .slice(0, visibleCount)
                                        .map((order) => {
                                            const targetItem = order.items.find(
                                                (item) =>
                                                    item.name === form.name
                                            );

                                            return targetItem ? (
                                                <TableRow key={order._id}>
                                                    <TableCell>
                                                        <Typography
                                                            variant="body2"
                                                            fontWeight="bold"
                                                        >
                                                            {order.orderCode}
                                                        </Typography>
                                                        <Typography
                                                            variant="body2"
                                                            color="textSecondary"
                                                        >
                                                            {new Date(
                                                                order.createdAt
                                                            ).toLocaleTimeString(
                                                                "vi-VN",
                                                                {
                                                                    hour: "2-digit",
                                                                    minute: "2-digit",
                                                                    hour12: false,
                                                                }
                                                            ) +
                                                                " " +
                                                                new Date(
                                                                    order.createdAt
                                                                ).toLocaleDateString(
                                                                    "vi-VN"
                                                                )}
                                                        </Typography>
                                                        <Typography
                                                            variant="body2"
                                                            color="textSecondary"
                                                        >
                                                            {
                                                                order.customer
                                                                    ?.name
                                                            }
                                                        </Typography>
                                                        <Typography variant="body2">
                                                            Giá vốn:{" "}
                                                            <span
                                                                style={{
                                                                    fontWeight:
                                                                        "bold",
                                                                }}
                                                            >
                                                                {" "}
                                                                {form.costPrice?.toLocaleString()}{" "}
                                                            </span>{" "}
                                                            ₫
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        <Typography
                                                            variant="body2"
                                                            fontWeight="bold"
                                                        >
                                                            {
                                                                targetItem.quantity
                                                            }
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        <Typography
                                                            variant="body2"
                                                            fontWeight="bold"
                                                        >
                                                            {
                                                                targetItem.lastQuantity
                                                            }
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : null;
                                        })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">
                                            <Typography>
                                                Không có đơn hàng
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {orders.length > visibleCount && (
                        <Box textAlign="center" mt={1}>
                            <Button
                                variant="outlined"
                                onClick={() =>
                                    setVisibleCount(visibleCount + 10)
                                }
                            >
                                Tải thêm sản phẩm
                            </Button>
                        </Box>
                    )}
                </Box>
            )}
        </Box>
    );
}
